/*
 * @Author: cjw 
 * @Date: 2021-03-31 10:53:39 
 * @Last Modified by: cjw
 * @Last Modified time: 2021-12-08 14:55:10
 */

import { reactive } from 'vue'

import { DataTable } from './data-table'
import { ProxyRelation } from './proxy/proxy-relation'

// 数据集
export function DataSet() {

    var pri = {
        dataMap: new Map(),
        // 保存所有通过 addTable 添加的表名，用于保存时取表
        tableNames: []
    }
    
    var pub = {
        addTable(name, dataTable) {
            if (!pri.dataMap.has(name)) {
                pri.dataMap.set(name, dataTable)

                // 提供使用名称获取数据表
                Object.defineProperty(this, name, {
                    get: function () {
                        return reactive(pri.dataMap.get(name))
                    },
                    enumerable: true,
                    configurable: true
                })

                pri.tableNames.push(name)

                return reactive(pri.dataMap.get(name))
            } else {
                throw `添加表失败，名称 ${name} 已存在！`
            }
        },

        createTable(name, target, options) {
            // 使用 reactive 是因为当数据表回滚时可以让界面刷新
            const observed = reactive(target)
            const dataTable = new DataTable(observed, options)
            return this.addTable(name, dataTable)
        },

        addRelation(name, masterName, detailName) {
            if (!pri.dataMap.has(name)) {
                if (!pri.dataMap.has(masterName)) {
                    throw `不存在名为 ${masterName} 的数据表`
                }
                if (!pri.dataMap.has(detailName)) {
                    throw `不存在名为 ${detailName} 的数据表`
                }

                // 主实体必须使用 reactive 包一层，否则主表当前活动记录变化不会响应
                const dtMaster = reactive(pri.dataMap.get(masterName))
                const dtDetail = pri.dataMap.get(detailName)

                const detailTable = new ProxyRelation(dtMaster, dtDetail)

                // 添加到集合中提供 get 访问
                pri.dataMap.set(name, detailTable)

                Object.defineProperty(this, name, {
                    get: function () {
                        return reactive(pri.dataMap.get(name))
                    },
                    enumerable: true,
                    configurable: true
                })

                return reactive(pri.dataMap.get(name))
            } else {
                throw `添加关系失败，名称 ${name} 已存在！`
            }
        },

        // 获取修改日志
        getChanges() {
            const datapack = {}
            pri.tableNames.forEach(name => {
                const dataTable = pri.dataMap.get(name)
                const changes = dataTable.getChanges()
                if (changes) {
                    datapack[name] = changes
                }
            })

            return datapack
        },

        // 提交自上次调用 acceptChanges 以来对该表进行的所有更改
        acceptChanges() {
            pri.tableNames.forEach(name => {
                const dataTable = pri.dataMap.get(name)
                dataTable.acceptChanges()
            })
        },

        // 拒绝自上次调用 acceptChanges 以来对该行进行的所有更改
        rejectChanges() {
            pri.tableNames.forEach(name => {
                const dataTable = pri.dataMap.get(name)
                dataTable.rejectChanges()
            })
        }
    }

    return pub
}